//= ../../node_modules/jquery/dist/jquery.js
//= ../../node_modules/svg4everybody/dist/svg4everybody.js
//= ../../node_modules/vanilla-lazyload/dist/lazyload.min.js
// = gdpr-billet.js


var windowWidth = $(document).width();

/* init lazy-load */
(function() {
    function logElementEvent(eventName, element) {
        element.getAttribute("data-bg")
    }
    var callback_error = function(element) {
        element.src =
            "https://via.placeholder.com/440x560/?text=Error+Placeholder";
    };
    var callback_loaded = function(element) {

    };

    var ll = new LazyLoad({
        elements_selector: ".lazy",
        threshold: 0,
        callback_loaded: callback_loaded,
        callback_error: callback_error
    });
})();


/* Cross-browser svg compatibility */
$(document).ready(function () {
    svg4everybody({});
});


/* ========== Header ========== */
/* burger-menu */
function burgerMenu() {
    var burgerBtn = $('.site-header .show-mobile-menu'),
        burgerDropdown = $('.site-header .header-nav');

    burgerBtn.on('click', function(e) {
        e.stopPropagation();

        if (burgerDropdown.hasClass('show')) {
            burgerDropdown.removeClass('show');
            $(this).removeClass('active');
        } else {
            burgerDropdown.addClass('show');
            $(this).addClass('active');
        }
    });

    $(document).click(function() {
        burgerDropdown.removeClass('show');
        burgerBtn.removeClass('active');
    });
}
burgerMenu();

/* search in header */
function searchInHeaderMobile() {
    var toggleBtn = $('.site-header .show-search-field'),
        headerSearchMobile = $('.site-header .search-form');

    toggleBtn.on('click', function() {
        if (headerSearchMobile.hasClass('show')) {
            headerSearchMobile.removeClass('show');
        } else {
            headerSearchMobile.addClass('show');
        }
    });

    $(document).mouseup(function(e) {
        if (!headerSearchMobile.is(e.target) && headerSearchMobile.has(e.target).length === 0 && !toggleBtn.is(e.target) && toggleBtn.has(e.target).length === 0) {
            headerSearchMobile.removeClass('show');
        }
    });
}
searchInHeaderMobile();
/* ========== Header ========== */


// cookies line
var gdpr = $('#gdpr'),
    gdprBtn = gdpr.find('.simple-btn'),
    gdprBtnClose = gdpr.find('.close-btn');

setTimeout(function () {
    gdpr.fadeIn();
}, 3000);

gdprBtnClose.on('click', function () {
    gdpr.fadeOut();
});

gdprBtn.on('click', function () {
    gdpr.fadeOut();
    $.ajaxSetup({
        headers: {'X-CSRF-TOKEN': '<?= csrf_token() ?>'}
    });
    $.ajax({
        type: "POST",
        url: "/set_coockies",
        success: function (data) {
        }
    });
});

<!--script for preloader-->
if ($('.preloader').length > 0) {
    setTimeout(function () {
        document.getElementById('mainPreloader').classList.add('fadeOut');
    }, 2000);
};

// more text on page product
$(".show-more a").on("click", function () {
    var $this = $(this);
    var $content = $this.parent().prev("div.all-description-game");
    var linkText = $this.text();

    if (linkText === "Show more") {
        linkText = "Show less";
        $content.addClass("showContent").removeClass("hideContent");
    }
    else {
        linkText = "Show more";
        $content.addClass("hideContent").removeClass("showContent");
    }

    $this.text(linkText);
    return false;
});

// // // scroll to top block  page Product
// // if (document.querySelector('.about-wrap')) {
//     var scrollToTopDistance = $('.about-wrap').offset().top;
//     function scrollToTop() {
//         $('html, body').animate({
//             scrollTop: scrollToTopDistance - 20
//         }, 300);
//     }
// // }


